<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="wrapper-page">
            <div class="container-box m-t-40">
              <div class="account-content">
                <form
                  v-if="!isVerifyToken"
                  class="form-horizontal"
                  @submit.prevent="login()"
                >
                  <div
                    class="form-group m-b-20"
                    :class="{ 'has-error': username.hasErrors }"
                  >
                    <div class="col-xs-12">
                      <label for="username">{{
                        trans("users.usernameLabel")
                      }}</label>
                      <input
                        id="username"
                        v-model="username.value"
                        v-focus
                        type="text"
                        class="form-control"
                        name="username"
                        required
                        :placeholder="trans('auth.usernameOrEmailPlaceholder')"
                      />

                      <span v-if="username.hasErrors" class="help-block">
                        <strong>{{ username.errorMessage }}</strong>
                      </span>
                    </div>
                  </div>
                  <div
                    class="form-group m-b-20"
                    :class="{ 'has-error': password.hasErrors }"
                  >
                    <div class="col-xs-12">
                      <label for="password">{{
                        trans("auth.passwordLabel")
                      }}</label>
                      <div class="input-group">
                        <input
                          id="password"
                          v-model="password.value"
                          :type="showPassword ? 'text' : 'password'"
                          class="form-control"
                          name="password"
                          required
                          autocomplete="password"
                        />
                        <div class="input-group-append">
                          <button
                            type="button"
                            class="btn btn-default"
                            @click="showPassword = !showPassword"
                          >
                            <i
                              :class="
                                showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                              "
                            ></i>
                          </button>
                        </div>
                      </div>

                      <span v-if="password.hasErrors" class="help-block">
                        <strong>{{ password.errorMessage }}</strong>
                      </span>
                    </div>
                  </div>

                  <div class="resend-btn">
                    <router-link to="/auth/password/reset">
                      {{ trans("auth.forgotPasswordLinkText") }}
                    </router-link>
                  </div>

                  <div class="form-group account-btn text-center m-t-10">
                    <div class="col-xs-12">
                      <clip-loader v-show="loading" />
                      <button
                        v-if="!loading"
                        class="btn btn-custom btn-block btn-lg"
                        type="submit"
                      >
                        {{ trans("auth.signUnLoginButton") }}
                      </button>
                    </div>
                  </div>
                </form>

                <form
                  v-if="isVerifyToken"
                  class="form-horizontal"
                  @submit.prevent="verify()"
                >
                  <div
                    class="form-group m-b-20"
                    :class="{ 'has-error': key.hasErrors }"
                  >
                    <div class="col-xs-12">
                      <label
                        v-if="method === 'username-password:sms'"
                        for="token"
                        >{{ trans("auth.keyLabel") }}</label
                      >
                      <label
                        v-if="method === 'username-password:auth-app'"
                        for="token"
                        >{{ trans("auth.authAppEnterCodePlaceholder") }}</label
                      >

                      <div class="code-inputs">
                        <input
                          id="verification-code"
                          ref="codeInput"
                          v-model="code"
                          type="text"
                          inputmode="numeric"
                          maxlength="6"
                          pattern="\d{6}"
                          class="form-control code-box"
                          autocomplete="one-time-code"
                          required="required"
                          :style="caretStyle"
                          @input="handleInput"
                        />
                      </div>

                      <span v-if="key.hasErrors" class="help-block">
                        <strong>{{ key.errorMessage }}</strong>
                      </span>
                    </div>
                  </div>

                  <div
                    v-if="method === 'username-password:sms'"
                    class="resend-btn"
                  >
                    <a v-if="resendAvailable" href="#" @click="resend()">{{
                      trans("auth.resendCode")
                    }}</a>
                    <span v-if="!resendAvailable">
                      {{ trans("auth.resendAvailableIn") }}
                      {{ resendAvailabilityTimer }}
                      {{ trans("auth.seconds") }}
                    </span>
                  </div>

                  <div class="form-group account-btn text-center m-t-10">
                    <div v-show="loading" class="col-xs-12">
                      <clip-loader />
                    </div>
                    <div v-if="!loading" class="col-xs-12">
                      <button
                        class="btn btn-custom btn-block btn-lg"
                        type="submit"
                      >
                        {{ trans("auth.tokenButtonConfirm") }}
                      </button>
                      <a class="btn btn-grey btn-block btn-lg" @click="back">{{
                        trans("general.back")
                      }}</a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <!-- end card-box-->
          </div>
          <!-- end wrapper -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { navigateToHomepage } from "./helpers/authHelpers";
import { initCsrf } from "../../app/practitioner-portal/auth/csrf";
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";

export default {
  props: {
    // username-password:sms or username-password:auth-app
    method: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resendAvailable: true,
      resendAvailableAfter: 20,
      resendAvailabilityTimer: 20,
      username: {
        value: "",
        hasErrors: false,
        errorMessage: "",
      },
      password: {
        value: "",
        hasErrors: false,
        errorMessage: "",
      },
      key: {
        value: "",
        hasErrors: false,
        errorMessage: "",
      },
      isVerifyToken: false,
      token: "",
      dermicusPlatform: "",
      code: "",
      showPassword: false,
    };
  },
  computed: {
    caretStyle() {
      return this.code.length > 5 ? { caretColor: "transparent" } : {};
    },
  },
  watch: {
    method() {
      this.back();
    },
    isVerifyToken(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          if (this.$refs.codeInput) {
            this.$refs.codeInput.focus();
          }
        });
      }
    },
  },
  mounted: function () {
    this.dermicusPlatform = window.dermicusPlatform;
    this.$nextTick(() => {
      if (this.$refs.codeInput) {
        this.$refs.codeInput.focus();
      }
    });
  },
  methods: {
    login: async function () {
      let instance = this;
      instance.loading = true;
      await initCsrf();
      let formData = {
        username: instance.username.value,
        password: instance.password.value,
        method: this.method,
      };
      practitionerHttpService
        .post("/api/internal/auth/sms", formData)
        .then((response) => {
          instance.loading = false;
          if (response.data.errors) {
            if (response.data.errors.username) {
              this.username.hasErrors = true;
              this.username.errorMessage = response.data.errors.username;
              this.username.value = response.data.inputs.username;
            }
          }

          instance.token = response.data.token;
          if (response.data.token) {
            this.isVerifyToken = true;
            instance.token = response.data.token;
          }
        })
        .catch(function (error) {
          if (error.response) {
            let status = error.response.status;
            let data = error.response.data;

            if (status === 422) {
              if (data.username) {
                instance.username.errorMessage = data.username[0];
                instance.username.hasErrors = true;
              }

              if (data.password) {
                instance.password.errorMessage = data.password[0];
                instance.password.hasErrors = true;
                instance.password.value = "";
              }
            }
          }

          instance.loading = false;
          instance.userErrorMessage(error);
        });
    },
    makeResendAvailable: function () {
      this.resendAvailabilityTimer = this.resendAvailableAfter;
      this.resendAvailable = false;
      let n = this.resendAvailableAfter;
      const tm = setInterval(countDown, 1000);
      const instance = this;

      function countDown() {
        n--;
        if (n === 0) {
          clearInterval(tm);
        }
        instance.resendAvailabilityTimer = n;
      }

      setTimeout(() => {
        this.resendAvailable = true;
      }, this.resendAvailableAfter * 1000);
    },
    resend: function () {
      let formData = { token: this.token, key: this.key.value };
      practitionerHttpService
        .post("/api/internal/auth/sms/resend", formData)
        .then((response) => {
          this.$notify({
            text: this.trans("auth.codeResent"),
            type: "success",
            duration: 1000,
          });
          this.makeResendAvailable();
        })
        .catch((error) => {
          this.userErrorMessage(error);
        });
    },
    verify: async function () {
      let instance = this;
      instance.loading = true;

      await initCsrf();
      let formData = { token: instance.token, key: this.code };
      practitionerHttpService
        .post("/api/internal/auth/" + this.method + "/verify", formData)
        .then((response) => {
          instance.loading = false;
          localStorage.removeItem("last_query_uri");
          navigateToHomepage(response);
        })
        .catch(function (error) {
          if (error.response) {
            let status = error.response.status;
            let data = error.response.data;

            if (status === 422 || status === 429) {
              if (data.key) {
                instance.key.errorMessage = data.key;
                instance.key.hasErrors = true;
              }
            }
          }

          instance.loading = false;
          instance.userErrorMessage(error);
        });
    },
    back: function () {
      this.isVerifyToken = false;
      this.token = "";
      this.key = {};

      this.username.hasErrors = false;
      this.username.errorMessage = "";
      this.password.hasErrors = false;
      this.password.errorMessage = "";
      this.key.hasErrors = false;
      this.key.errorMessage = "";
    },
    handleInput(event) {
      const value = event.target.value.replace(/\D/g, "");
      if (/^\d{0,6}$/.test(value)) {
        this.code = value;
      }
    },
  },
};
</script>

<style>
.code-inputs {
  display: flex;
  gap: 8px;
}
</style>
